export const getIsServer = () => {
    return typeof window === 'undefined';
};
